
namespace RecordShield.Wallet {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class PaymentDetailsDialog extends Serenity.EntityDialog<PaymentDetailsRow, any> {
        protected getFormKey() { return PaymentDetailsForm.formKey; }
        protected getIdProperty() { return PaymentDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return PaymentDetailsRow.localTextPrefix; }
        protected getNameProperty() { return PaymentDetailsRow.nameProperty; }
        protected getService() { return PaymentDetailsService.baseUrl; }

        protected form = new PaymentDetailsForm(this.idPrefix);

        constructor() {
            super();
            
            if (this.isNew()) {
                this.form.CreditPriceId.changeSelect2(e => {
                    var productId = this.form.CreditPriceId.value.toString();
                    this.form.CouponCode.value = "";
                    this.form.DiscountAmount.value = null;
                    if (Q.isEmptyOrNull(productId)) {  
                        this.form.PayableAmount.value = null;
                        Q.alert("Please Select Credits");
                        return;
                    }
                    var CreditPrice = Q.tryFirst(Wallet.CreditPriceRow.getLookup().items, x => x.Id.toString() == productId);
                    if (CreditPrice != null) {

                        this.form.Credits.value = CreditPrice.NumberofCredits;
                        this.form.CreditAmount.value = CreditPrice.Price;
                        this.form.PayableAmount.value = CreditPrice.Price;
                    }
                  
                });
                this.form.CouponCode.change(e => {
                    var CouponCode = this.form.CouponCode.value;
                    if (CouponCode != "") {

                        var productId = this.form.CreditPriceId.value.toString();
                        if (Q.isEmptyOrNull(productId)) {
                            Q.alert("Please Select Credits First");
                            return;
                        }
                        Q.reloadLookup("Wallet.Coupons");
                        var Coupon = Q.tryFirst(CouponsRow.getLookup().items, x => x.CouponCode == CouponCode);
                        if (Coupon == null) {
                            Q.alert("Invalid Coupon Code: " + this.form.CouponCode.value);
                            this.form.CouponCode.value = null;
                            return;
                        }
                        else {
                            if (Coupon.IsActive != 1) {
                                Q.alert("Coupon Code " + this.form.CouponCode.value +" Expired:01");
                                this.form.CouponCode.value = null;
                                return;
                            }
                            debugger;
                            PaymentDetailsService.Retrieve2({
                                EntityId: Coupon.Id
                            }, response => {
                                debugger;
                                if (response.Entity.SpecificUsers == null) {
                                    var Discount;
                                    if (response.Entity.DiscountType == 1) {
                                        Discount = response.Entity.DiscountAmount;
                                    }
                                    else {
                                        Discount = this.form.CreditAmount.value * (response.Entity.DiscountPercentage / 100);
                                    }
                                    if (Discount < this.form.CreditAmount.value) {
                                        this.form.DiscountAmount.value = Number(Discount);
                                        this.form.PayableAmount.value = this.form.CreditAmount.value - this.form.DiscountAmount.value
                                    }
                                    else {
                                        Q.alert("Discount amount cannot be Greater than Credit Amount.");
                                        this.form.PayableAmount.value == null;
                                        this.form.CouponCode.value = null;
                                        return
                                    }
                                    if (response.Entity.DiscountType == 1) {
                                        Q.notifySuccess("Coupon Code Applied Successfully : Discount Amount Rs: " + response.Entity.DiscountAmount);                                        
                                    }
                                    else {
                                        Q.notifySuccess("Coupon Code Applied Successfully : Discount Amount Rs: " + Discount);
                                    }
                                    this.form.CouponId.value = response.Entity.Id.toString();
                                    
                                }
                                else {
                                    this.form.CouponCode.value = null;
                                    Q.alert(response.Entity.SpecificUsers);
                                }

                            });
                        }
                    }
                    else {
                        this.form.DiscountAmount.value = 0;
                        this.form.PayableAmount.value = this.form.CreditAmount.value;
                    }

            });

            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            debugger;            
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons[0].title = "Pay";
            buttons[0].cssClass = "";
            return buttons;
        }

        protected onSaveSuccess(response: Serenity.SaveResponse): void {

            // check that this is an insert
            if (this.isNew) {
                PaymentDetailsService.Retrieve(<any>{
                    EntityId: response.EntityId
                }, resp => {
                    window.location.href = resp.Entity.PaymentUrl;
                    });
            }
        }
    }
}